import {Pagination} from 'react-bootstrap'
import styled from 'styled-components'

const Wrapper = styled.div`
  .page-item .page-link {
    font-size: 11px !important;
  }
`

interface PaginationTableProps {
  links: {
    url: string | null
    label: string
    active: boolean
  }[]
  firstPageUrl: string
  lastPageUrl: string
  onPageChange: (page: string) => void
}

export const PaginationTable = ({
  links,
  firstPageUrl,
  lastPageUrl,
  onPageChange,
}: PaginationTableProps) => {
  const handlePageChange = (pageUrl: string | null) => {
    if (!pageUrl) return
    const url = new URL(pageUrl ?? '')
    onPageChange(url.searchParams.get('page') ?? '')
  }

  return (
    <Wrapper>
      <Pagination>
        <Pagination.First onClick={() => handlePageChange(firstPageUrl)} />
        {links.map((item: {url: string | null; label: string; active: boolean}, idx: number) => {
          return (
            <Pagination.Item
              key={idx}
              active={item.active}
              onClick={() => handlePageChange(item.url)}
            >
              {item.label.replace('&laquo; Previous', '<').replace('Next &raquo;', '>')}
            </Pagination.Item>
          )
        })}
        <Pagination.Last onClick={() => handlePageChange(lastPageUrl)} />
      </Pagination>
    </Wrapper>
  )
}
